import { render, staticRenderFns } from "./TripSidebarSectionItem.vue?vue&type=template&id=71c9d4b0"
import script from "./TripSidebarSectionItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./TripSidebarSectionItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports